import React from 'react';
import { connect } from 'react-redux';
import Counter from './Counter';

class ListSectionCounter extends React.Component {
  render() {
    return <Counter value={this.props.checked?.length} />;
  }
}

const mapStateToProps = (state, ownProps) => {
  if (
    state.fields &&
    state.records.current &&
    (state.records.current.record || state.records.current.reflection)
  ) {
    let record =
      ownProps.field === 'meaningful_activities'
        ? state.records.current.reflection
        : state.records.current.record;
    return {
      fields: state.fields[ownProps.field], //return a copy of each field, so not change field directly
      checked: record?.fields?.[ownProps.field] || [],
    };
  }
  return {};
};

export default connect(mapStateToProps)(ListSectionCounter);
